import { UpgradeSubscriptionButton } from "components/action-buttons/action-buttons";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "components/ui/card";

interface AccessControlModalProps {
  title: string;
  children?: React.ReactNode;
  imageLight: string;
  imageDark: string;
}

export const AccessControlModal = (props: AccessControlModalProps) => {
  return (
    <Card className="absolute top-1/2 left-1/2 w-2xl -translate-x-1/2 -translate-y-1/2 shadow-xl">
      <CardHeader>
        <CardTitle>{props.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row gap-4">
          {props?.children}
          <img src={props.imageLight} alt="" className="size-60 object-cover dark:hidden" />
          <img src={props.imageDark} alt="" className="size-60 object-cover hidden dark:block" />
        </div>
      </CardContent>
      <CardFooter className="justify-end">
        <UpgradeSubscriptionButton />
      </CardFooter>
    </Card>
  );
};
